import { Typography } from "@/components/ui";
import { cn } from "@/lib/utils";
import type { SectionKey, StepDefinition } from "@/pages/public/repairIntakeForm/repairIntakeFormConstants";

type RepairIntakeStepNavigationProps = {
  activeStep: number;
  sectionErrors: Set<SectionKey>;
  steps: readonly StepDefinition[];
  onGoToStep: (stepIndex: number) => void;
};

export function RepairIntakeStepNavigation({
  activeStep,
  sectionErrors,
  steps,
  onGoToStep,
}: RepairIntakeStepNavigationProps) {
  return (
    <div className="grid gap-3 md:grid-cols-3 xl:grid-cols-9">
      {steps.map((step, index) => {
        const isActive = index === activeStep;
        const isComplete = index < activeStep && !sectionErrors.has(step.key);
        const hasError = sectionErrors.has(step.key);

        return (
          <button
            key={step.key}
            type="button"
            onClick={() => onGoToStep(index)}
            className={cn(
              "rounded-lg border px-3 py-3 text-left transition-colors",
              isActive && "border-primary bg-primary/5",
              isComplete && "border-emerald-300 bg-emerald-50",
              hasError && "border-destructive bg-destructive/5",
              !isActive && !isComplete && !hasError && "border-gray-200 bg-white"
            )}
          >
            <Typography variant="text-xs" weight="semibold" className="text-gray-500">
              Step {index + 1}
            </Typography>
            <Typography variant="text-small" weight="medium" className="mt-1">
              {step.title.replace(/^Section \d+:\s/, "")}
            </Typography>
          </button>
        );
      })}
    </div>
  );
}
